import fetch from '@/utils/fetch';
// 获取保证金订单列表
export function getMarginList(data) {
  return fetch({
    url: '/saas/order/m/s/margin/list',
    method: 'post',
    data: data,
  });
}
// 获取保证金订单详情
export function getOrderDetail(data) {
  return fetch({
    url: '/saas/order/m/s/margin/view',
    method: 'post',
    data: data,
  });
}
// 保证金订单退款
export function refundOrder(data) {
  return fetch({
    url: '/saas/order/m/s/margin/refund',
    method: 'post',
    data: data,
  });
}

// 比例保证金支付列表
export function marginPayList(data) {
  return fetch({
    url: '/saas/order/m/s/margin/order/item/list',
    method: 'post',
    data: data,
  });
}
// 比例保证金锁定拍品列表
export function marginArtworkList(data) {
  return fetch({
    url: '/saas/cms/m/s/frozen/auction/artwork/list',
    method: 'post',
    data: data,
  });
}
// 比例保证金额度变动记录
export function marginRatioChangeList(data) {
  return fetch({
    url: '/saas/cms/m/s/margin/ratio/quota/list',
    method: 'post',
    data: data,
  });
}

// 比例保证金额度变更
export function marginRatioChange(data) {
  return fetch({
    url: '/saas/cms/m/s/margin/ratio/quota/change',
    method: 'post',
    data: data,
  });
}
